module.exports = __webpack_public_path__ + "img/image_3.534a7424.png";